import { all } from 'redux-saga/effects';
import { UsersManagementSaga } from 'src/views/users/reduxStore/saga';
import { ApiKeysManagementSaga } from 'src/views/api-keys/reduxStore/saga';
import aggregatedDataSaga from '../common/store/aggregatedData/saga';
import CompaniesManagementSaga from '../common/store/company/saga';
import CSVDataSaga from '../common/store/csvData/saga';
import DepartmentsManagementSaga from '../common/store/department/saga';
import GatewaysSaga from '../common/store/gateways/saga';
import GroupsManagementSaga from '../common/store/group/saga';
import GroupDevicesManagementSaga from '../common/store/groupDevices/saga';
import GroupStoresManagementSaga from '../common/store/groupStores/saga';
import HistoryDataSaga from '../common/store/historyData/saga';
import LastSequenceSaga from '../common/store/lastSequence/saga';
import LatestDataSaga from '../common/store/latestData/saga';
import LoggersManagementSaga from '../common/store/logger/saga';
import MissingDataSaga from '../common/store/missingData/saga';
import MultiGraphSaga from '../common/store/multiGraph/saga';
import RealtimeDataSaga from '../common/store/realtimeData/saga';
import ReceiversManagementSaga from '../common/store/receiver/saga';
import StoresManagementSaga from '../common/store/store/saga';
import TrendGraphSaga from '../common/store/trendGraph/saga';
import unitsChannelsSaga from '../common/store/unitsChannels/saga';
import VersionSaga from '../common/store/version/saga';
import DashboardSaga from '../views/data/dashboard/saga';
import GPSDashboardSaga from '../views/data/gps-dashboard/reduxStore/saga';
import LastDataSaga from '../views/data/last-data/saga';
import ResetPasswordSaga from '../views/public/forgot-password/reduxStore/saga';
import LoginSaga from '../views/public/login/saga';
import ActivateUserSaga from '../views/public/register/reduxStore/saga';
import ChannelSettingsSaga from '../views/settings/channel-settings/saga';
import UserSaga from '../common/store/user/saga';

/*
 * Combines all the existing sagas from /common/store/... and /views/...
 */
export default function* rootSaga() {
  yield all([
    LoginSaga(),
    ResetPasswordSaga(),
    ActivateUserSaga(),
    LastDataSaga(),
    DashboardSaga(),
    GPSDashboardSaga(),
    ChannelSettingsSaga(),
    aggregatedDataSaga(),
    RealtimeDataSaga(),
    GatewaysSaga(),
    unitsChannelsSaga(),
    LatestDataSaga(),
    UsersManagementSaga(),
    GroupsManagementSaga(),
    GroupDevicesManagementSaga(),
    GroupStoresManagementSaga(),
    ReceiversManagementSaga(),
    LoggersManagementSaga(),
    CompaniesManagementSaga(),
    DepartmentsManagementSaga(),
    StoresManagementSaga(),
    LastSequenceSaga(),
    HistoryDataSaga(),
    CSVDataSaga(),
    MissingDataSaga(),
    MultiGraphSaga(),
    TrendGraphSaga(),
    VersionSaga(),
    UserSaga(),
    ApiKeysManagementSaga(),
  ]);
}
